<template>
  <div class="container my-4">
    <router-link :to="{ name: 'ConfigurationFiltersView', query: { deviceName: encodeURI(this.deviceName) } }">
      <fa-icon :icon="['fas', 'chevron-left']" class="mr-2" />{{ deviceName }} Filterkategorien
    </router-link>
    <div class="d-flex align-items-center justify-content-between mt-3 mb-4">
      <h4 class="mb-0">{{ name }}</h4>
      <div>
        <b-button variant="outline-primary" v-on:click="hinzufuegen">
          <fa-icon :icon="['fas', 'plus']" class="mr-2" />Filter erstellen
        </b-button>
      </div>
    </div>
    <form v-on:submit.prevent="speichern" v-if="isLoading === false">
      <b-form-group>
        <label for="name">Bezeichnung</label>
        <b-input id="name" v-model="name"></b-input>
      </b-form-group>
      <b-form-group>
        <label for="type">Typ</label>
        <b-select id="type" v-model="type">
          <b-select-option value="">Hardwareauswahl</b-select-option>
          <b-select-option value="color">Farbauswahl</b-select-option>
        </b-select>
      </b-form-group>
      <h5>Filter</h5>
      <b-table striped :items="filter" :fields="fields" empty-text="Keine Daten vorhanden" show-empty>
        <template #cell(name)="row">
          <b-input v-model="row.item.name"></b-input>
        </template>

        <template #cell(color)="row">
          <b-input v-model="row.item.color" placeholder="#000000" v-show="type === 'color'"></b-input>
        </template>

        <template #cell(actions)="row">
          <div class="d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              title="Löschen"
              v-on:click="filterEntfernen(row.item.id)"
            >
              <fa-icon icon="trash" />
            </button>
          </div>
        </template>
      </b-table>

      <SaveButtonComponent :saveButtonState="saveButtonState" />
    </form>
    <SpinnerComponent v-else />
  </div>
</template>

<script>
import SpinnerComponent from "../components/SpinnerComponent";
import SaveButtonComponent from "../components/SaveButtonComponent";

import { firestore } from '../plugins/firebase'
import { getDoc, doc, updateDoc } from "firebase/firestore"

export default {
  name: "EditConfigurationFilterView",
  components: {
    SpinnerComponent,
    SaveButtonComponent,
  },
  computed: {
    deviceName() {
      return decodeURI(this.$route.query.deviceName);
    },
    filterName() {
      return decodeURI(this.$route.query.filterName);
    },
    filterId() {
      return decodeURI(this.$route.params.filterId);
    },
    deviceId() {
      return decodeURI(this.$route.params.deviceId);
    },
  },
  data() {
    return {
      isLoading: true,
      name: "",
      saveButtonState: "",
      filter: [],
      type: "",
      color: "",
      fields: [
        {
          key: "name",
          label: "Bezeichnung",
        },
        {
          key: "color",
          label: "Farbwert",
        },
        {
          key: "actions",
          label: "",
        },
      ],
    };
  },
  mounted() {
    this.laden();
  },
  methods: {
    hinzufuegen() {
      this.filter.push({
        name: "",
        color: "",
        id: this.generiereId(10),
      });
    },
    async laden() {
        getDoc(doc(firestore, "filter", this.filterId))
        .then((document) => {
          if (document.exists) {
            this.name = document.data().name;
            this.type = document.data().type;
            this.filter = document.data().filter;
          }
        })
        .then(() => {
          this.isLoading = false;
        })
        .catch((error) => console.error(error)); // eslint-disable-line no-console
    },
    generiereId: function(idLength) {
      const alphaNum = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let id = "";
      for (let i = 0; i < idLength; i++) {
        id += alphaNum.charAt(Math.floor(Math.random() * alphaNum.length));
      }
      return id;
    },
    filterEntfernen: function(id) {
      for (let i = 0; i < this.filter.length; i++) {
        if (this.filter[i].id === id) {
          this.filter.splice(i, 1);
          i--;
        }
      }
    },
    async speichern() {
      this.saveButtonState = "saving";
      updateDoc(doc(firestore, "filter", this.filterId),{
          name: this.name,
          type: this.type,
          filter: this.filter,
        })
        .then(() => {
          this.saveButtonState = "done";
          setTimeout(() => {
            this.saveButtonState = "";
          }, 3500);
        })
        .catch((error) => {
          console.error(error);
          this.saveButtonState = "error";
          setTimeout(() => {
            this.saveButtonState = "";
          }, 3500);
        }); // eslint-disable-line no-console
    },
  },
};
</script>
